"use strict";
require('../../layouts/web')



$('.address-slider').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
    dots: true,
    margin: 10,
    responsiveClass: true,
})

$(".service_select2, .product_select2").select2({
    placeholder: function() {
        return $(this).data('placeholder') || "Select an option";
    },
    allowClear: true,  
    closeOnSelect: false,
    allowHtml: true
});